import React, {PureComponent} from "react";
import {Sidebar, Card} from "semantic-ui-react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

class MobileTips extends PureComponent {
  static propTypes = {
    hexColorCodeC: PropTypes.string,
    tips: PropTypes.string,
    visible: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidUpdate(nextProps) {
    this.setState({visible: nextProps.visible});
  }

  renderTips() {
    return (
      <div className="content shaded padded"
           dangerouslySetInnerHTML={{ __html: this.props.tips }}>
      </div>
    )
  }

  handleClose = () => {
    this.props.toggleVisibility();
  };

  render() {
    const { hexColorCodeC } = this.props;
    return (
        <Sidebar
          visible={this.props.visible}
          id="mobileApply"
          className="ui top"
        >
          <Card id="applyCard" className="ui fluid">
            <div className="content" style={{ backgroundColor: `#${hexColorCodeC}` }}>
              <div className="header">
                <h2 style={{ color: `white`, display: 'inline-block' }}>Tips</h2>
                <span className="close-sidebar" onClick={this.handleClose}>x</span>
              </div>
            </div>
            {this.renderTips()}
          </Card>
        </Sidebar>
    );
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default connect(mapStatesToProps)(MobileTips);



// WEBPACK FOOTER //
// ./src/components/common/MobileTips.js